
// src/web/components/diary-url-links.jsx

import React from 'react'
import connect from '../../connects/diary-upload-files'
import { themr } from 'react-css-themr'
import diaryTheme from './themes/diary.css'
import {
  CardText,
} from 'react-toolbox/lib/card'
import Avatar from 'react-toolbox/lib/avatar'
import Chip from 'react-toolbox/lib/chip'
import GoogleIcons from '../../assets/google-icons'
import imageChipTheme from './themes/image-chip.css'
import _ from 'lodash'

@themr('Diary', diaryTheme)
class DiaryUrlLinks extends React.Component {
  render() {
    const {
      t,
      theme,
      urlLinks,
      onDeleteLink,
      isChat
    } = this.props

    if (!urlLinks || Object.keys(urlLinks).length == 0)
      return null

    return (
      <CardText theme={theme} className={isChat ? "chatLinks" : "links"} >
        {_.map(urlLinks, (link, url)=> 
          link.title &&
          <Chip key={url} theme={link.image_url && imageChipTheme || undefined} deletable onDeleteClick={()=> onDeleteLink(url)}>
            {link.image_url && <img className={imageChipTheme.image} src={link.image_url}/>}
            {link.mime_type && <img className={imageChipTheme.image} src={GoogleIcons[link.mime_type] || GoogleIcons['default']}/>}
            {link.title && <span>{link.title.length > 30 ? link.title.slice(0, 30) + '...' : link.title}</span>}
          </Chip>
        )}
      </CardText>
    )
  }
}

export default DiaryUrlLinks



// WEBPACK FOOTER //
// ./src/web/components/diary-url-links.jsx